import React, { ComponentProps, FC, ReactNode } from 'react';
import LazyLoad from 'react-lazyload';

import config from 'components/LazyLoadComponents/config';
import { getCloudProductImage } from 'server/helpers/cloudImage';

import { ImageChangingOnHover } from './ImageChangingOnHover';

const buildProductImagesUrl = (imagesList: string[]): string[] => {
  const images = imagesList.map(image => {
    return getCloudProductImage(image, 'mini');
  });
  return images;
};

export const ProductImageCard: FC<{
  height?: string;
  lazyLoad?: boolean;
  placeholder?: ReactNode;
  width?: string;
} & ComponentProps<typeof ImageChangingOnHover>> = props => {
  const { images, lazyLoad, width, height } = props;
  const imagesUrls = buildProductImagesUrl(images);
  const newProps = { ...props, images: imagesUrls };

  return !lazyLoad ? (
    <ImageChangingOnHover {...newProps} />
  ) : (
    <LazyLoad height={height} width={width} {...config.productImageCard}>
      <ImageChangingOnHover {...newProps} />
    </LazyLoad>
  );
};
